import Component from '@glimmer/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import EmberTooltip from 'ember-tooltips/components/ember-tooltip';
import type VisitComposite from 'garaje/models/visit-composite';

interface RecurringRuleCellSignature {
  Args: {
    row: VisitComposite;
  };
}

export default class RecurringRuleCell extends Component<RecurringRuleCellSignature> {
  get isRecurring(): boolean {
    const { row } = this.args;
    return row.recurringRule !== null && !row.parsedRecurringRule.isBlank();
  }

  get recurringRuleText(): string | null {
    const { row } = this.args;
    return row.parsedRecurringRule.toText();
  }

  <template>
    <div class="flex flex-col" data-test-recurring-rule-cell>
      {{#if this.isRecurring}}
        {{#if this.recurringRuleText}}
          <EmberTooltip @side="top-start" @text={{this.recurringRuleText}} />
        {{/if}}
        {{svgJar "recurring" height="24" width="24"}}
      {{/if}}
    </div>
  </template>
}
